package org.vreo.devicehub.features.core.domain.device.message

import kotlinx.serialization.Serializable

/**
 * Anpr messages request dto, requests messages associated with [deviceId].
 *
 * @param limit maximum number of messages to be retrieved
 * @param fromTime unix timestamp in seconds from when time to filter messages
 * @param toTime unix timestamp in seconds to time to filter messages
 * @param ignoreIds messages ID's to ignore, those are messages that have already been obtained
 */
@Serializable
data class AnprMessagesRequestDto(
    val deviceId: String,
    val limit: Int = 20,
    val fromTime: Long? = null,
    val toTime: Long? = null,
    val ignoreIds: List<String>? = null
)